import { render, staticRenderFns } from "./onlineDes.vue?vue&type=template&id=35f72d7a"
import script from "./onlineDes.vue?vue&type=script&lang=js"
export * from "./onlineDes.vue?vue&type=script&lang=js"
import style0 from "./onlineDes.vue?vue&type=style&index=0&id=35f72d7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports